import React, { useEffect, useRef } from 'react'

interface BackgroundWebcamProps {
  config?: string
  size: { width?: number; height?: number }
  style?: Record<string, string>
}

const BackgroundWebcam = ({ config, size, style }: BackgroundWebcamProps): JSX.Element => {
  const videoRef = useRef<HTMLVideoElement>(null)

  const setSource = (constraints: MediaStreamConstraints) => {
    navigator.mediaDevices
      .getUserMedia(constraints)
      .then((stream) => {
        if (videoRef.current) {
          videoRef.current.srcObject = stream
        }
      })
      .catch((error) => console.warn('Retorik Framework > an error occured when trying to use the webcam : ', error))
  }

  useEffect(() => {
    setSource({
      video: {
        facingMode: config === 'back' ? { exact: 'environment' } : config === 'front' ? 'user' : undefined,
        deviceId: ['back', 'front', undefined].includes(config) ? undefined : config,
        ...size
      }
    })
  }, [config, size])

  return (
    <video
      ref={videoRef}
      id='retorik-background-webcam'
      className='rf-relative rf-col-span-full rf-row-span-full rf-overflow-hidden rf-max-w-none rf-w-screen rf-h-screen rf-filter rf-blur-background rf-border rf-self-center rf-justify-self-center rf-object-cover rf-origin-center'
      style={{
        ...style
      }}
      autoPlay
      muted={true}
      playsInline
    />
  )
}

export default BackgroundWebcam
